import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
  setInteractionMode,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import pt_BR from "vee-validate/dist/locale/pt_BR.json";

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize({
  pt_BR,
});

const timeValidator = (value) => {
  if (value.length < 5) return false;
  const [horas, minutos] = value.split(":").map((val) => parseInt(val, 10));
  return horas < 24 && minutos < 60;
};

extend("timeValidator", timeValidator);

const nisValidator = (value) => {
  const nis = String(value).replace(/\D/g, "");
  if (!/^\d{11}$/.test(nis) || /^(\d)\1{10}$/.test(nis)) return false;
  const soma = [3, 2, 9, 8, 7, 6, 5, 4, 3, 2].reduce((acc, peso, i) => acc + peso * nis[i], 0);
  const resto = soma % 11;
  return (resto < 2 ? 0 : 11 - resto) === Number(nis[10]);
};

extend("nis", { validate: nisValidator, message: "O NIS informado é inválido." });

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);
localize("pt_BR");
setInteractionMode("eager");
